module.exports = __webpack_public_path__ + "img/img4zhounq-4.a1be4c4a.png";